export default __webpack_public_path__ + "static/media/tempInstructor.f38f33f3.jpg";